import React, { useState, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";

// 국기 이미지
import img_flag_kr from "../assets/img_flag_kr.svg";
import img_flag_en from "../assets/img_flag_en.svg";
import img_flag_cn from "../assets/img_flag_cn.svg";
import img_flag_vi from "../assets/img_flag_vi.png";
import img_flag_th from "../assets/img_flag_th.png";

const languageImage = {
    ko: img_flag_kr,
    en: img_flag_en,
    cn: img_flag_cn,
    vi: img_flag_vi,
    th: img_flag_th
};

const languageText = {
    ko: "KOREA",
    en: "ENGLISH",
    cn: "CHINESE",
    vi: "VIETNAM",
    th: "THAILAND"
};

const Header = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [headerClass, setHeaderClass] = useState("sub");

    const [data, setData] = useState();
    const [searchParams] = useSearchParams();

    const [langShow, setLangShow] = useState("");

    useEffect(() => {
        let token = searchParams.get("token");
        if (!!token) {
            localStorage.setItem("fb_token", token);
        } else {
            token = localStorage.getItem("fb_token");
        }

        if (!!token && data) {
            data.fb_token = token;
            Update(
                data,
                res => {
                    localStorage.setItem("fb_token", "");
                },
                res => {}
            );
        }
    }, [searchParams, data]);

    useEffect(() => {
        if (location.pathname === "/") {
            setHeaderClass("main");
        } else {
            setHeaderClass("sub");
        }
    }, [location]);

    useEffect(() => {
        AuthMe(
            res => {
                setData(res);
            },
            res => {
                setData();
            }
        );

        return () => {};
    }, []);

    const clickLogout = () => {
        setData();
        localStorage.setItem("access_token", "");
        localStorage.setItem("refresh_token", "");
        localStorage.setItem("token_type", "");
        localStorage.setItem("expires_in", "");
        window.location = "/";
    };

    const findNextKey = currentKey => {
        const keys = Object.keys(languageImage);
        const currentIndex = keys.indexOf(currentKey);

        if (currentIndex !== -1) {
            const nextIndex = (currentIndex + 1) % keys.length;
            return keys[nextIndex];
        }

        return keys[0];
    };

    function langMenuToggle() {
        setLangShow(!langShow);
    }

    return (
        <header className={`header-wrapper ${headerClass}`}>
            {/* pc 메뉴 */}
            <div className="inner">
                <h1 className="logo">
                    <Link to="/">{t("효심")}</Link>
                </h1>
                <nav className="gnb">
                    <ul>
                        <li className={window.location.pathname === "/about" ? "active" : ""}>
                            <Link to={data ? "/about" : "/login"}>
                                <i className="icon monitor"></i>
                                {t("생체 신호 모니터링")}
                            </Link>
                        </li>
                        <li className={window.location.pathname === "/statistics" ? "active" : ""}>
                            <Link to={data ? "/statistics" : "/login"}>
                                <i className="icon statistics"></i>
                                {t("통계")}
                            </Link>
                        </li>
                        {/* <li className={window.location.pathname === "/emergency" ? "active" : ""}>
                            <Link to={data ? "/emergency" : "/login"}>
                                <i className="icon alarm"></i>
                                {t("긴급 알림")}
                            </Link>
                        </li> */}
                        <li className={window.location.pathname === "/mypage" ? "active" : ""}>
                            <Link to={data ? "/mypage" : "/login"}>
                                <i className="icon mypage"></i>
                                {t("마이페이지")}
                            </Link>
                        </li>
                        <li></li>
                    </ul>
                </nav>
                <div className="btn_box">
                    {!data && (
                        <Link className="orange" to="/login">
                            {t("로그인")}
                        </Link>
                    )}
                    {!data && (
                        <Link className="line" to="/join">
                            {t("회원가입")}
                        </Link>
                    )}
                    {data && (
                        <Link className="orange" onClick={clickLogout}>
                            {t("로그아웃")}
                        </Link>
                    )}

                    {/* <Link
                        className="language"
                        onClick={() => {
                            i18n.changeLanguage(findNextKey(i18n.language));
                        }}
                    >
                        <img src={languageImage[i18n.language]} alt="" />
                    </Link> */}
                    <div className="language_top_wrapper">
                        {/* show 클래스 추가 시 밑에 언어 리스트 보임 */}
                        <Link className={`language_top_select ${langShow ? "show" : ""}`} onClick={langMenuToggle}>
                            {languageText[i18n.language]}
                        </Link>
                        <ul className="language_top_list">
                            {Object.keys(languageText).map(key => {
                                if (i18n.language !== key) {
                                    return (
                                        <li
                                            onClick={() => {
                                                i18n.changeLanguage(key);
                                                langMenuToggle();
                                            }}
                                        >
                                            <Link>{languageText[key]}</Link>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                </div>
                {/* 모바일 뒤로가기 버튼 - 메인 페이지에서는 보이지 않게 */}
                <div className="mobile_btns">
                    {!data && (
                        <Link className="orange" to="/login">
                            {t("로그인")}
                        </Link>
                    )}
                    {!data && (
                        <Link className="line" to="/join">
                            {t("회원가입")}
                        </Link>
                    )}
                    {window.history.state.idx > 0 && (
                        <button
                            type="button"
                            className="mobile_back"
                            onClick={() => {
                                window.history.back();
                            }}
                        >
                            {t("뒤로가기")}
                        </button>
                    )}
                    <div className="language_top_wrapper" >
                        {/* show 클래스 추가 시 밑에 언어 리스트 보임 */}
                        <Link className={`language_top_select ${langShow ? "show" : ""}`} onClick={langMenuToggle}>
                            {languageText[i18n.language]}
                        </Link>
                        <ul className="language_top_list">
                            {Object.keys(languageText).map(key => {
                                if (i18n.language !== key) {
                                    return (
                                        <li
                                            onClick={() => {
                                                i18n.changeLanguage(key);
                                                langMenuToggle();
                                            }}
                                        >
                                            <Link>{languageText[key]}</Link>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                    {data && (
                        <Link className="orange" onClick={clickLogout}>
                            {t("로그아웃")}
                        </Link>
                    )}
                </div>
            </div>

            {/* 모바일 메뉴 */}
            <nav className="mobile_gnb">
                <ul>
                    <li className={window.location.pathname === "/about" ? "active" : ""}>
                        <Link to={data ? "/about" : "/login"}>
                            <i className="icon monitor"></i>
                            <span>{t("모니터링")}</span>
                        </Link>
                    </li>
                    <li className={window.location.pathname === "/statistics" ? "active" : ""}>
                        <Link to={data ? "/statistics" : "/login"}>
                            <i className="icon statistics"></i>
                            <span>{t("통계")}</span>
                        </Link>
                    </li>
                    <li className={window.location.pathname === "/" ? "active" : ""}>
                        <Link to="/">
                            <i className="icon home"></i>
                            <span>{t("홈")}</span>
                        </Link>
                    </li>
                    {/* <li className={window.location.pathname === "/emergency" ? "active" : ""}>
                        <Link to={data ? "/emergency" : "/login"}>
                            <i className="icon alarm"></i>
                            <span>{t("긴급 알림")}</span>
                        </Link>
                    </li> */}
                    <li className={window.location.pathname === "/mypage" ? "active" : ""}>
                        <Link to={data ? "/mypage" : "/login"}>
                            <i className="icon mypage"></i>
                            <span>{t("마이페이지")}</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;
